// @flow
import React from "react";
import { localize } from "redux-i18n";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  View,
  Button,
  type ButtonColor,
} from "@components";

type Props = {
  headerText: string,
  bodyContent?: string | React$Node, //TODO: Refactor by replacing bodyContent with children
  children?: React$Node,
  bodyClass?: string,
  rightPanel?: boolean,
  width?: string,
  confirmBtnLabel?: string,
  confirmBtnDisabled?: boolean,
  confirmBtnIcon?: string,
  confirmBtnColor?: ButtonColor,
  cancelBtnColor?: ButtonColor,
  cancelBtnLabel?: string,
  cancelBtnDisabled?: boolean,
  footerContent?: string | React$Node,
  className?: string,
  onConfirm?: Function,
  onCancel?: Function,
  modalSize?: "fullscreen" | "large" | "normal" | "small",
  ...PropsFromLocalize,
};

export function ConfirmationModal(props: Props) {
  return (
    <Modal
      rightPanel={!!props.rightPanel}
      className={`modal-${props.modalSize || "small"} ${props.className || ""}`}
    >
      <ModalHeader toggle={props.onCancel || null}>
        {props.headerText || "Please confirm"}
      </ModalHeader>
      <ModalBody className={props.bodyClass || ""}>
        {props.bodyContent || props.children || (
          <div>Content should be provided thry bodyContent or children props.</div>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        {props.footerContent || <div />}
        <View direction="row" gap="4">
          {props.onCancel ? (
            <Button
              disabled={!!props.cancelBtnDisabled}
              color={props.cancelBtnColor || "secondary"}
              onClick={props.onCancel}
            >
              {props.cancelBtnLabel || props.t("CANCEL")}
            </Button>
          ) : null}
          {props.onConfirm ? (
            <Button
              disabled={!!props.confirmBtnDisabled}
              materialIcon={props.confirmBtnIcon}
              color={props.confirmBtnColor || "primary"}
              onClick={props.onConfirm}
            >
              {props.confirmBtnLabel || props.t("OK")}
            </Button>
          ) : null}
        </View>
      </ModalFooter>
    </Modal>
  );
}
export default localize()(ConfirmationModal);
